var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "card-body p-0" },
      [
        [
          _c("v-data-table", {
            staticClass: "elevation-1",
            attrs: {
              headers: _vm.headers,
              items: _vm.items.data,
              options: _vm.options,
              "server-items-length": _vm.items.total,
              loading: _vm.loading,
              "footer-props": {
                "items-per-page-options": [5, 10, 50, 100],
              },
            },
            on: {
              "update:options": function ($event) {
                _vm.options = $event
              },
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "item.created_at",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm._f("DATETIME")(item.created_at)) +
                          "\n                "
                      ),
                    ]
                  },
                },
              ],
              null,
              true
            ),
          }),
        ],
      ],
      2
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-header" }, [
      _c("h5", { staticClass: "me-auto" }, [_vm._v("Historial de Paquete")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }